import { useAuthStore } from '@/stores/auth';

export const useAuth = () => {
  const store = useAuthStore();
  
  return {
    user: store.user,
    isAuthenticated: store.isAuthenticated,
    isLoading: store.isLoading,
    error: store.error,
    login: store.login,
    register: store.register,
    logout: store.logout,
    refreshAccessToken: store.refreshAccessToken,
    updateProfile: store.updateProfile,
    changePassword: store.changePassword,
    checkAuth: store.checkAuth,
    clearError: store.clearError,
  };
};
